export type SolveFeatures = TimelineFeatures & WorkspaceFeatures;

export interface TimelineFeatures {
    helpMeNowQuestion: string;
    isAutoCompleteEnabled: boolean;
    isGuidedFlowRecommendationEnabled: boolean;
    isHelpMeNowEnabled: boolean;
    isOutageAlertInfoEnabled: boolean;
    isProactiveEnabled: boolean;
    isProactiveSuggestionEnabled: boolean;
    isReactiveCallContextEnabled: boolean;
    isReactiveCallContextV2Enabled: boolean;
    isSalesFAQEnabled: boolean;
    proactiveSuggestionInterval: number;
}

export const defaultHelpMeNowQuestion = "Help the customer with their technical problem";
export const defaultProactiveSuggestionInterval = 60000;

export interface WorkspaceFeatures {
    customFlowSystemId?: string;
    isDeviceActivationGuideIntentAutoOpenEnabled: boolean;
    isGuidedFlowRecommendationEnabled: boolean;
    isOutageAlertInfoEnabled: boolean;
    isPreviousSessionSummaryEnabled: boolean;
    isProactiveEnabled: boolean;
    isSimplrGuideEnabled: boolean;
    isSolveLeaderboardEnabled: boolean;
    isVerizonCareEnabled: boolean;
    isLightModeEnabled?: boolean;
}

export type TimelineContextType = Record<keyof TimelineFeatures, boolean | number | string>;
export type WorkspaceContextType = Record<keyof WorkspaceFeatures, boolean | string | undefined>;

// group name used for analytics
export type Group = "Timeline" | "Workspace";
